import styled from 'styled-components'

/** Ancho del icono (12px) + separación con el nombre (6px), según Figma */
export const ICON_OUTSIDE_OFFSET_PX = 18

export const TooltipTitle = styled.div`
  text-align: center;
  font-family: Roboto, sans-serif;
`

export const IconSlot = styled.span<{ $inline?: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 16px;
  flex-shrink: 0;

  ${({ $inline }) =>
    $inline
      ? `
    position: relative;
    margin-right: 6px;
  `
      : `
    position: absolute;
    left: 0;
    top: 50%;
    margin-left: -${ICON_OUTSIDE_OFFSET_PX}px;
    transform: translateY(-50%);
    z-index: 2;
  `}

  svg {
    color: #d48806;
    font-size: 12px;
    line-height: 16px;
  }
`
